import React from 'react';
import CurrencyInput from './CurrencyInput.tsx';
import InfoIcon from './InfoIcon.tsx';

type IconComponent = React.ComponentType<{ size?: number; className?: string }>;

interface AllocationInputProps {
    icon: IconComponent;
    label: React.ReactNode;
    name: string;
    value: number | string | null | undefined;
    onChange: (name: string, value: number | undefined) => void;
    max: number;
    disabled?: boolean;
    tooltip?: string;
}

const AllocationInput = ({ icon: Icon, label, name, value, onChange, max, disabled, tooltip }: AllocationInputProps) => (
    <div>
        <label className="block text-sm font-medium text-gray-700 mb-0.5 flex items-center">
            <Icon size={16} className="mr-2 text-gray-600" /> {label} {tooltip && <InfoIcon text={tooltip} />}
        </label>
        <div className="flex items-center gap-2">
            <input
                type="range"
                min="0"
                max={max}
                value={value || 0}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(name, parseFloat(e.target.value) || 0)}
                className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-600 disabled:opacity-50"
                disabled={disabled}
            />
            {/* w-40, not w-32: the old 128px left about 94px of text room once the input's px-4 was
                taken off, and a seven-figure allocation ("$2,612,500") was clipped mid-number —
                which on an allocator is not cosmetic, it is the figure the reader is setting
                (owner-caught, 2026-08-26). 160px carries eight figures with room to spare. The
                slider gives up the width; it is the coarse control, the number is the exact one. */}
            <div className="w-40 shrink-0">
                <CurrencyInput
                    value={value ?? ''}
                    onChange={(v) => onChange(name, v)}
                    placeholder="0"
                    disabled={disabled}
                    className=""
                />
            </div>
        </div>
    </div>
);

export default AllocationInput;
